import React from "react";
import CQStencilsStick from "./components/cq-stencil-stick";

import './cqStencil.css'
import { useLocation } from "react-router-dom";

// These number of items fits pefectly with currrent diemnsions
const NUM_OF_TASKS = 8
const NUM_OF_TIMELINE_ITEMS = 3
const NUM_OF_TIMELINE_SUB_ITEMS = 7

function Tasks() {
  const items: React.ReactNode[] = []
  for (let i = 0; i < NUM_OF_TASKS; i++) {
    items.push(
      <div
        style={{
          // Decrease the opacity sequentially
          opacity: Math.pow(1 / 1.3, i),
        }}
        className="slds-box slds-col slds-theme_shade slds-size_12-of-12 slds-var-m-bottom_x-small slds-p-around_medium cq-flex cq-align-center"
      >
        <div
          className="slds-theme_default slds-var-m-right_small cq-h-1 cq-w-1 cq-radius-half"
        ></div>
        <CQStencilsStick height="sm" shade={false} />
      </div>
    )
  }
  return items
}

function TimelineSubItems() {
  const items: React.ReactNode[] = []
  for (let i = 0; i < NUM_OF_TIMELINE_SUB_ITEMS; i++) {
    items.push(<CQStencilsStick className="slds-var-m-bottom_xx-small" />)
  }
  return items
}

function TimelineItems() {
  const items: React.ReactNode[] = []
  for (let i = 0; i < NUM_OF_TIMELINE_ITEMS; i++) {
    items.push(
      <div className="cq-flex cq-h-33p">
        <div className="cq-flex cq-flex-column">
          <div
            className="slds-theme_shade cq-h-1.5 cq-w-1.5 cq-radius-.2"
          ></div>
          <div
            className="slds-theme_shade cq-flex-1 cq-m-l-auto cq-m-r-auto cq-w-.14"
          ></div>
        </div>
        <div className="slds-var-m-left_x-small cq-flex-1">
          <div className="slds-var-m-bottom_xx-small slds-var-m-top_xx-small ">
            <CQStencilsStick className="slds-var-m-bottom_xx-small" />
            <CQStencilsStick width="small" />
          </div>
          <div className="slds-box slds-var-m-bottom_small">
            {TimelineSubItems()}
          </div>
        </div>
      </div>
    )
  }
  return items
}

export default function CQStencil() {
  const location = useLocation();

  // Check if pathname includes '/push-portal'
  const isPushPortal = location.pathname.includes('/push-portal');
  return (
    isPushPortal ? CQPushPortalStencil() : CQDeploymentAgentStencil()
  );
}

function CQDeploymentAgentStencil() {
  return (
    <div
      className="cq-h-100vh cq-flex cq-flex-column"
    >
      <div className="slds-grid">
        <div className="slds-col slds-size_12-of-12 ">
          <div
            className="slds-box slds-col slds-theme_default slds-size_12-of-12 cq-h-3"
          ></div>
        </div>
      </div>
      <div
        className="slds-grid slds-m-around_medium cq-flex cq-h-90p"
      >
        <div
          className="slds-col slds-size_12-of-12 cq-flex cq-flex-column cq-h-full"
        >
          <div className="slds-grid cq-h-10p">
            <div
              className="slds-box slds-col slds-theme_default slds-size_12-of-12 cq-flex"
            >
              <div
                className="slds-box slds-theme_shade slds-var-m-right_small cq-w-2 cq-h-2 cq-radius-half"
              ></div>
              <CQStencilsStick height="lg" width="small" />
            </div>
          </div>
          <div className="slds-grid cq-h-90p">
            <div className="slds-col slds-size_8-of-12 slds-box slds-theme_default slds-var-m-top_medium">
              <div
                className="slds-grid slds-box slds-p-around_none cq-h-full"
              >
                <div
                  className="slds-col slds-size_3-of-12 cq-flex cq-flex-column"
                >
                  <div
                    className="slds-p-horizontal_x-small slds-p-vertical_small cq-h-3"
                  >
                    <CQStencilsStick className="slds-m-bottom_xx-small" />
                    <CQStencilsStick width="small" />
                  </div>
                  <div
                    className="slds-box slds-theme_shade cq-flex-1"
                  >
                    <div className="slds-var-m-bottom_small">
                        <CQStencilsStick
                          className="slds-m-bottom_xx-small"
                          shade={false}
                        />
                        <CQStencilsStick width="small" shade={false} />
                    </div>
                    <div className="slds-var-m-bottom_small">
                      <CQStencilsStick
                        className="slds-m-bottom_xx-small"
                        shade={false}
                      />
                      <CQStencilsStick width="small" shade={false} />
                    </div>
                  </div>
                </div>
                <div
                  className="slds-col slds-var-m-left_medium cq-h-full cq-overflow-hidden"
                >
                  <div className="cq-flex cq-h-3">
                    <CQStencilsStick
                      className="slds-m-bottom_xx-small cq-align-self-end"
                      width="small"
                    />
                  </div>
                  <div
                    className="slds-var-m-right_medium"
                  >
                    <hr className="slds-m-vertical_none slds-p-bottom_x-small" />
                    <div
                      className="slds-m-bottom_x-small cq-h-2"
                    >
                      <div
                        className="cq-flex cq-flex-column cq-align-end cq-m-l-auto cq-h-30p"
                      >
                        <CQStencilsStick className="slds-m-bottom_xx-small" height="md" width="small" />
                        <CQStencilsStick width="small" />
                      </div>
                    </div>
                    <div>
                      {Tasks()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="slds-col slds-size_4-of-12 slds-box slds-theme_default slds-var-m-left_xx-small slds-var-m-top_medium cq-h-fit"
            >
              {TimelineItems()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CQPushPortalStencil() {
  return (
    <div className="cq-h-100vh cq-flex cq-flex-column">
      {/* Top Nav Bar */}
      <div className="slds-grid">
        <div className="slds-col slds-size_12-of-12 ">
          <div
            className="slds-box slds-col slds-theme_default slds-size_12-of-12 cq-h-3"
          ></div>
        </div>
      </div>

      {/* Page Header */}
      <div className="slds-grid slds-m-around_medium">
        <div className="slds-col slds-size_12-of-12 slds-box slds-theme_default cq-flex cq-align-center cq-h-4">
          <div className="slds-box slds-theme_shade cq-w-2 cq-h-2 slds-var-m-right_small"></div>
          <div className="slds-col slds-size_3-of-12">
            <CQStencilsStick width="full" className="slds-var-m-bottom_x-small" />
            <CQStencilsStick width="full" />
          </div>
          <div className="cq-m-l-auto slds-col slds-size_3-of-12 cq-flex">
            <CQStencilsStick width="small" className="slds-var-m-right_small" height="md" />
            <CQStencilsStick width="small" className="slds-var-m-right_small" height="md" />
            <CQStencilsStick width="half" height="md" />
          </div>
        </div>
      </div>

      {/* Upgrade Activity Section */}
      <div className="slds-grid slds-var-m-horizontal_medium">
        <div className="slds-col slds-size_12-of-12 slds-box slds-theme_default">

          {/* Section Title */}
          <div className="slds-var-m-bottom_small slds-col slds-size_3-of-12">
            <CQStencilsStick width="small" height="md"/>
          </div>

          {/* Tabs */}
          <div className="cq-flex slds-var-m-bottom_x-small slds-col slds-size_2-of-12">
            <CQStencilsStick width="small" className="slds-var-m-right_small" />
            <CQStencilsStick width="small" className="slds-var-m-right_small" />
            <CQStencilsStick width="small" />
          </div>

          <hr className="slds-m-vertical_none slds-var-m-bottom_small" />

          {/* Table Rows */}
          {[1,2,3,4].map((i) => (
            <div key={i} className="slds-grid slds-var-m-bottom_x-small slds-var-m-top_x-small slds-box slds-theme_shade">
              <div className="slds-col slds-size_3-of-12"><CQStencilsStick width="half" shade={false} /></div>
              <div className="slds-col slds-size_2-of-12"><CQStencilsStick width="half" shade={false} /></div>
              <div className="slds-col slds-size_2-of-12"><CQStencilsStick width="small" shade={false} /></div>
              <div className="slds-col slds-size_2-of-12"><CQStencilsStick width="small" shade={false} /></div>
              <div className="slds-col slds-size_2-of-12"><CQStencilsStick width="half" shade={false} /></div>
              <div className="slds-col slds-size_1-of-12"><CQStencilsStick width="half" shade={false} /></div>
            </div>
          ))}

          {/* Pagination */}
          <div className="slds-col slds-size_2-of-12 cq-align-center slds-var-m-top_small">
            <CQStencilsStick width="small" />
          </div>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="slds-grid slds-var-m-horizontal_medium slds-var-m-top_small">
        <div className="slds-col slds-size_12-of-12 slds-box slds-theme_default cq-flex cq-align-center">

          {/* Filter Mode */}
          <div className="slds-var-m-right_medium slds-col slds-size_2-of-12">
            <CQStencilsStick width="small" className="slds-var-m-bottom_x-small" />
            <div className="cq-flex">
              <CQStencilsStick width="small" height="md" className="slds-var-m-right_xx-small" />
              <CQStencilsStick width="small" height="md" />
            </div>
          </div>

          {/* Version Dropdown */}
          <div className="slds-col slds-size_3-of-12 slds-var-m-right_medium">
            <CQStencilsStick width="small" className="slds-var-m-bottom_xx-small" />
            <CQStencilsStick width="full" height="md" />
          </div>

          {/* Org Type Dropdown */}
          <div className="slds-col slds-size_2-of-12 slds-var-m-right_medium">
            <CQStencilsStick width="small" className="slds-var-m-bottom_xx-small" />
            <CQStencilsStick width="full" height="md" />
          </div>

          {/* Search */}
          <div className="slds-col slds-size_3-of-12 slds-var-m-right_medium">
            <CQStencilsStick width="small" className="slds-var-m-bottom_xx-small" />
            <CQStencilsStick width="full" height="md" />
          </div>

          {/* Schedule Button */}
          <div className="cq-m-l-auto slds-col slds-size_1-of-12">
            <CQStencilsStick width="full" height="lg"/>
          </div>
        </div>
      </div>

      {/* Registered Orgs Section */}
      <div className="slds-grid slds-var-m-horizontal_medium slds-var-m-top_small">
        <div className="slds-col slds-size_12-of-12 slds-box slds-theme_default">

          {/* Section Title */}
          <div className="slds-var-m-bottom_small slds-col slds-size_3-of-12">
            <CQStencilsStick width="small" />
          </div>

          {/* Pagination top */}
          <div className="cq-flex cq-align-center slds-var-m-bottom_small">
          <div className="slds-col slds-size_2-of-12">
            <CQStencilsStick width="small" />
            </div>
            <div className="cq-m-l-auto cq-flex slds-size_1-of-12">
              <CQStencilsStick width="full" height="md" className="slds-var-m-right_x-small" />
              <CQStencilsStick width="full" height="md" />
            </div>
          </div>

          {/* Org Rows */}
          {[1, 2, 3].map((i) => (
            <div key={i} className="slds-grid slds-box slds-theme_shade slds-var-m-bottom_small cq-flex cq-align-center">
              {/* Checkbox */}
              <div className="slds-box slds-theme_default cq-w-1 cq-h-1 slds-var-m-right_small"></div>

              {/* Org Info */}
              <div className="slds-col slds-size_4-of-12">
                <div className="cq-flex cq-align-center slds-var-m-bottom_xx-small">
                  <CQStencilsStick width="small" className="slds-var-m-right_x-small" shade={false} />
                </div>
                <CQStencilsStick width="half" shade={false} />
              </div>

              {/* Actions */}
              <div className="cq-m-l-auto cq-flex slds-size_1-of-12">
                <CQStencilsStick width="full" height="md" className="slds-var-m-right_x-small" shade={false} />
                <CQStencilsStick width="full" height="md" shade={false} />
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}